export enum CodeMirrorModes {
    Transformer = 'transformer_parser',
    GenAI = 'genai',
    XML = 'xml',
    JSON = 'json'
}
